import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);



// WEBPACK FOOTER //
// ./src/plugins/vue-resource/index.js